module.exports = __webpack_public_path__ + "media/images/communities/logos/ao9-3fce1682de33d5b977c2eca8b51e6d4b.png";